/**
 * Eine gerade angelegte Geschichte fragt beim ersten Öffnen nach ihren Story Beats (PLAN.md §42): Die Übersicht merkt sich die Geschichte
 * für diese Sitzung, die Projektseite fragt und vergisst sie dann.
 */
const KEY = 'dispositio.beatSetup';

export function requestBeatSetup(projectId: string): void {
  try {
    sessionStorage.setItem(KEY, projectId);
  } catch {
    // ohne Speicher: kein Fenster
  }
}

/** Soll die Geschichte nach ihren Story Beats fragen? */
export function wantsBeatSetup(projectId: string): boolean {
  try {
    return sessionStorage.getItem(KEY) === projectId;
  } catch {
    return false;
  }
}

export function doneBeatSetup(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nichts zu tun
  }
}
